// src/app/services/meta-pixel.service.ts
import { Injectable } from '@angular/core';

declare let fbq: Function;

@Injectable({
  providedIn: 'root'
})
export class MetaPixelService {

  private readonly pixelId = '2755601098109943';

  // Call once on app init to load the pixel script
  initialize(): void {
    if (typeof window === 'undefined') return;

    // Avoid double-loading
    if ((window as any).fbq) return;

    // Inject the Meta Pixel base code
    (function(f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function() {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
      t = b.createElement(e); t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    fbq('init', this.pixelId);

    // Inject noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width  = 1;
    img.style.display = 'none';
    img.src = `https://www.facebook.com/tr?id=${this.pixelId}&ev=PageView&noscript=1`;
    noscript.appendChild(img);
    document.head.appendChild(noscript);
  }

  // Track a page view — call this on every route change
  trackPageView(): void {
    if (typeof fbq === 'undefined') return;
    fbq('track', 'PageView');
  }

  // Track volunteer form submission
  trackVolunteerSignup(): void {
    if (typeof fbq === 'undefined') return;
    fbq('track', 'Lead', {
      content_name: 'Volunteer Signup',
      content_category: 'Campaign'
    });
  }

  // Track petition form request (mail request)
  trackPetitionRequest(): void {
    if (typeof fbq === 'undefined') return;
    fbq('track', 'Lead', {
      content_name: 'Petition Forms Request',
      content_category: 'Constitutional Captains'
    });
  }

  // Track donate button click
  trackDonateClick(): void {
    if (typeof fbq === 'undefined') return;
    fbq('track', 'InitiateCheckout', {
      content_name: 'Donate Button Click',
      content_category: 'Donation'
    });
  }

  // Track PDF download
  trackPDFDownload(): void {
    if (typeof fbq === 'undefined') return;
    fbq('track', 'ViewContent', {
      content_name: 'Constitutional Captains Package Download',
      content_category: 'Constitutional Captains'
    });
  }

  // Track contact form submission
  trackContactSubmit(): void {
    if (typeof fbq === 'undefined') return;
    fbq('track', 'Contact', {
      content_name: 'Contact Form Submission',
      content_category: 'Campaign'
    });
  }

  // Track donate page view
  trackDonatePageView(): void {
    if (typeof fbq === 'undefined') return;
    fbq('track', 'ViewContent', {
      value: 25,
      currency: 'USD',
      content_type: 'product'
    });
  }
}
